namespace RioERP.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}

